/*
Author: zhengdongzhou
Date: 2023-02-15
Desc: 页面填写错误自动滑动到相应位置 并提示具体错误信息
*/

export function errorScroll(_this, options, callback) {
    if (_this && options) {
        _this.$util.showMessage(_this, "warning", options);
    }
    this.$nextTick(() => {
        let errorElements = document.getElementsByClassName("is-error");
        errorElements[0].scrollIntoView({
            block: "center",
            behavior: "smooth"
        });
        if (callback) {
            if (typeof callback !== "function") {
                throw new TypeError(callback + "is not a function");
            } else {
                callback();
            }
        }
    });
}
